import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Replace this with your Firebase project configuration
// You can find this in your Firebase console
const firebaseConfig = {
    apiKey: "AIzaSyBIRi-tfHGm8lfxMyNz6yvU9hj98x1VtGs",
    authDomain: "venue-planner-3d48a.firebaseapp.com",
    projectId: "venue-planner-3d48a",
    storageBucket: "venue-planner-3d48a.firebasestorage.app",
    messagingSenderId: "465134147349",
    appId: "1:465134147349:web:ebba7fe2e56b1506b1bb1c",
    measurementId: "G-PMXJJ8SXT2"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);

export default app; 